const defaultMessages = {
    ':email': 'Veuillez entrer un email valide.',
    ':phone': 'Veuillez entrer un numéro de téléphone dans un format valide (0x xx xx xx xx ou +33x xx xx xx xx).',
}

function addIntermediateKeys(fields) {
    const existing = new Set(fields.map(f => f.name))
    const result = [...fields]

    for (const { name, message } of fields) {
        const parts = name.split('.')
        for (let i = 1; i < parts.length; i++) {
            const subKey = parts.slice(0, i).join('.')
            if (!existing.has(subKey)) {
                existing.add(subKey)
                result.push({ name: subKey, message })
            }
        }
    }

    return result
}

function getFirstMatchingMessage(key, validationSuffixes, messages) {
    for (const suffix of validationSuffixes) {
        const messageKey = `:${suffix.replace('validation.', '')}`
        if (messages[key + messageKey]) {
            return messages[key + messageKey]
        }
        if (messages[messageKey]) {
            return messages[messageKey]
        }
    }
    return ' '
}

export default function (errors: object, messages = {}) {

    return addIntermediateKeys(Object.entries(errors).map(([key, value]) => {
        return { name: key, message: getFirstMatchingMessage(key, value, {...defaultMessages, ...messages}) }
    }))
}